module.exports = __webpack_public_path__ + "img/gerasimos-michalitsis.b74e10f8.jpg";